<template>
  <div class="iphone-container">
    <!-- iPhone Frame -->
    <div class="iphone-frame">
      <!-- Dynamic Notch -->
      <div class="iphone-notch">
        <div class="camera"></div>
        <div class="sensor"></div>
        <div class="speaker"></div>
      </div>
      <!-- Screen Content -->
      <div class="screen">
        <!-- Module Image Container with overlay -->
        <div class="white-margin-around image-container">
          <!-- If there is an image URL, show it as a background -->
          <div
              v-if="moduleImage"
              :style="{ backgroundImage: 'url(' + moduleImage + ')' }"
              class="background-image"
          ></div>

          <!-- Otherwise, show a fixed‐size grey placeholder -->
          <div v-else class="background-placeholder"></div>

          <!-- Overlay text + button always sits at bottom of that box -->
          <div class="overlay-text">
            <p class="module-text">{{ textInModule }}</p>
            <button
                v-if="isButtonInModuleActive"
                class="history-btn btn btn-w-m"
                disabled
            >
              {{ moduleButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoyaltyPointHistoryMobilePreview",
  props: {
    initialModuleImage: String,
    initialTextInModule: String,
    initialIsButtonInModuleActive: {
      type: [Boolean, String],
      default: false
    },
    initialModuleButtonText: String
  },
  data() {
    return {
      moduleImage: this.initialModuleImage || null,
      textInModule: this.initialTextInModule || "",
      isButtonInModuleActive: this.parseBoolean(this.initialIsButtonInModuleActive),
      moduleButtonText: this.initialModuleButtonText || ""
    };
  },
  watch: {
    initialModuleImage(newVal) {
      this.moduleImage = newVal || null;
    },
    initialTextInModule(newVal) {
      this.textInModule = newVal || "";
    },
    initialModuleButtonText(newVal) {
      this.moduleButtonText = newVal || "";
    },
    initialIsButtonInModuleActive: {
      immediate: true,
      handler(newValue) {
        this.isButtonInModuleActive = this.parseBoolean(newValue);
      }
    }
  },
  methods: {
    parseBoolean(value) {
      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        return normalized === "true" || normalized === "1";
      }
      return value === true || value === 1;
    }
  },
  mounted() {
    window.addEventListener("module-image-selected", (event) => {
      this.moduleImage = event.detail;
    });

    window.addEventListener("text-in-module-updated", (event) => {
      this.textInModule = event.detail;
    });

    window.addEventListener("is-button-in-module-active-updated", (event) => {
      this.isButtonInModuleActive = this.parseBoolean(event.detail);
    });

    window.addEventListener("module-button-text-updated", (event) => {
      this.moduleButtonText = event.detail;
    });
  }
};
</script>

<style scoped>
/* Container for centering the iPhone preview */
.iphone-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* iPhone Frame */
.iphone-frame {
  width: 390px; /* iPhone width */
  height: 844px; /* iPhone height */
  background: #fff;
  border-radius: 40px;
  border: 8px solid #222;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* Notch (Dynamic Island style) */
.iphone-notch {
  width: 140px;
  height: 35px;
  background: #222;
  border-radius: 20px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px;
}

/* Notch elements */
.camera {
  width: 12px;
  height: 12px;
  background: black;
  border-radius: 50%;
}

.sensor {
  width: 8px;
  height: 8px;
  background: grey;
  border-radius: 50%;
}

.speaker {
  width: 40px;
  height: 5px;
  background: darkgray;
  border-radius: 3px;
}

/* Screen area */
.screen {
  flex-grow: 1;
  background: white;
  padding: 0;
  margin-top: 50px; /* Space for notch */
  position: relative;
}

/* Image container to allow overlay positioning */
.image-container {
  position: relative;
}

/* Background Image (moduleImage) */
.background-image {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* Grey placeholder if no image is selected */
.background-placeholder {
  width: 100%;
  height: 200px;
  background-color: #efefef;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* Overlay text container positioned at bottom left */
.overlay-text {
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  color: black;
}

/* Module text styling */
.module-text {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  white-space: pre-wrap; /* Preserves newlines and spaces */
}

/* Conditionally displayed button */
.history-btn {
  margin-top: 10px;
  padding: 7px 35px;
  background: black;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: small;
}

.white-margin-around {
  margin: 10px;
}
</style>
